import { BORDER_LIGHT, TEXT_DARK, TEXT_MUTED, BG_CARD } from './designTokens';

interface FloorplanSearchProps {
  query: string;
  onChange: (query: string) => void;
  resultCount: number;
}

export function FloorplanSearch({ query, onChange, resultCount }: FloorplanSearchProps) {
  return (
    <div style={{ position: 'relative', marginBottom: '0.75rem' }}>
      <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', width: '280px' }}>
        <input
          type="text"
          value={query}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Search tables or guests..."
          style={{
            width: '100%',
            padding: '0.45rem 2rem 0.45rem 0.65rem',
            fontSize: '0.8rem',
            border: `1px solid ${BORDER_LIGHT}`,
            borderRadius: '6px',
            backgroundColor: BG_CARD,
            color: TEXT_DARK,
            outline: 'none',
          }}
          aria-label="Search tables or guests"
        />
        {query && (
          <button
            onClick={() => onChange('')}
            style={{
              position: 'absolute',
              right: '6px',
              top: '50%',
              transform: 'translateY(-50%)',
              border: 'none',
              background: 'transparent',
              cursor: 'pointer',
              fontSize: '0.9rem',
              color: TEXT_MUTED,
              padding: '0 4px',
              lineHeight: 1,
            }}
            aria-label="Clear search"
          >
            ✕
          </button>
        )}
      </div>
      {/* Aria-live region for result count */}
      <div
        aria-live="polite"
        aria-atomic="true"
        style={{
          fontSize: '0.7rem',
          color: TEXT_MUTED,
          marginTop: '0.25rem',
          minHeight: '1em',
        }}
      >
        {query
          ? resultCount > 0
            ? `${resultCount} table${resultCount !== 1 ? 's' : ''} found`
            : 'No results found'
          : ''}
      </div>
    </div>
  );
}
